<template>
    <div v-show="pageData.length > 0">
        <div>
            <span class="common-title">流转记录</span>
        </div>
        <div class="chart-box"><div id="tableChart" :style="'height:' + chartHeight +'px'"></div></div>
        <goldDetailDialog ref="goldDetailDialog" :id.sync="goldDetailDialogId" :isFnc.sync="isFnc"/>
    </div>
</template>

<script>
import {mapGetters} from "vuex"
import { queryTransRecord } from "@/api/gold.js"
import goldDetailDialog from "./gold-detail-dialog"
export default {
    name:"gold-detail-flow-record",
    data() {
        return {
            pageData:[],
            showMore:false,
            goldDetailDialogId:undefined,
            isFnc:undefined,
            myChart:null,
            chartHeight:3
        }
    },
    components:{
        goldDetailDialog
    },
    computed: {
        ...mapGetters({
            parentData:"app/getGoldDetailPrarms",
            getUserObj:"home/getUserObj"
        }),
        way(){
            if(this.parentData){
                return this.parentData.way;
            }
            return this.$route.params.way;
        },
        gldId(){
            if(this.parentData){
                return this.parentData.gldId;
            }
            return this.$route.params.gldId;
        },
        gldStCds(){
            const fromType = this.parentData?this.parentData.fromType:this.$route.params.fromType;
            switch(fromType){
                case "3":
                    return "0,1,5,6,7";
                case "5":
                    return "";
                default:
                    return  "";
            }
        }
    },
    created() {
        this.queryPayRecord();
    },
    mounted() {
        let self = this;
        window.clickChartTreeNode = function(e, isFin){
            self.$nextTick(() => {
                setTimeout(() => {
                    self.myChart.dispatchAction({
                        type: 'hideTip',         //提示框
                    });
                },2000)
                self.goldDetailDialogId = e;
                self.isFnc = (isFin == "祺信融资"); //判断是否为融资的祺信
                console.log(self.isFnc)
                self.$refs.goldDetailDialog.open();
            })
        }
    },
    methods: {
        queryPayRecord(){
            let param = {
                gldStCds:this.gldStCds,
                gldId:this.gldId
            }
            queryTransRecord(param)
            .then((res) => {
                this.pageData = res.data.list||[];
                let max = this.pageData.length >= 3 ? 2: this.pageData.length;
                this.chartHeight = this.pageData.length ? 180 * max : this.chartHeight;
                this.renderTreeData();
            }).catch(err => {
                console.log(err);
            });
        },
        renderTreeData(){
            let list = [{name:"",children:[],isParent:true}];
            let parent = this.pageData.filter(i => i.isSon == 0);
            if(parent.length > 0){
                list[0].name = parent[0].pypt;
                list[0].isParent = true;
                list[0].children = [
                    {...parent[0],name:parent[0].rcPty,children:[],isSelf:true}
                ];
                let hideList = [2,3,4,8]; //根据祺信状态判断不显示的数据
                let thirdChidren = [];
                let childrenIds = [];
                this.pageData.forEach(item => {
                    if(item.isSon == 1 && childrenIds.indexOf(item.gldId) == -1 && hideList.indexOf(+item.gldStCd) == -1){
                        if(item.goldTransferType == 1){
                            item.name = item.rcPty;
                        }
                        else{
                            item.name = item.tenantName;
                        }
                        thirdChidren.push(item);
                        childrenIds.push(item.gldId)
                    }
                })
                list[0].children[0].children = thirdChidren;
                this.$nextTick(() => {
                    this.initChart(list);
                    console.log(list)
                })
            }
        },
        initChart(data){
            let self = this;
            let chartDom = document.getElementById("tableChart");
            this.myChart = this.$echarts.init(chartDom);

            let option = {
                tooltip: {
                    trigger: 'item',
                    triggerOn: 'mousemove|click',
                    enterable:true,
                    position:function(point,params){
                        return point;
                    },
                    formatter:function(param){
                        if(param.data.isParent){
                            return param.data.name;
                        }
                        let e = param.data.gldId;
                        let isFin = self.goldTransferTypeFun2(param.data);
                        return `<div>祺信状态：${self.GbGldStCdTrans(param.data.gldStCd)}</div><div style="">祺信编号：${param.data.gldId}</div><div style="">交易对手：${param.data.name}</div><a onclick="clickChartTreeNode('${e}','${isFin}')" style="color:#4daaff;text-decoration: underline;">查看祺信详情</a>`;
                    }
                },
                series:[
                    {
                        type: 'tree',
                        id: 0,
                        name: 'tree1',
                        data: data,
                        top: '0',
                        left: '0',
                        bottom: '30%',
                        right: '0',
                        scale:false,
                        move:false,
                        symbolSize: 25,
                        orient: 'vertical',
                        edgeShape: 'polyline',
                        edgeForkPosition: '20%',
                        // initialTreeDepth: 2,

                        lineStyle: {
                            width: 1
                        },

                        label: {
                            // overflow:'truncate',
                            backgroundColor: '#fff',
                            position: 'bottom',
                            verticalAlign: 'middle',
                            align: 'center',

                            formatter:function(param){
                                if(param.data.isParent){
                                    return `{a|}\n\n\n{blue|${param.data.name}}`;
                                }
                                return `{b|${self.getName(param.data)}}\n` + `{d|（${self.utils.splitK(Math.abs(param.data.transMoney))}元 ${self.utils.dateFormat(new Date(param.data.transferTime),'yyyy-MM-dd')}）}\n` + self.getStatusHtml(param.data);
                            },
                            textStyle:{
                                lineHeight:20
                            },
                            rich:{
                                a:{
                                    padding:10,
                                },
                                b:{
                                    color: '#1990FF',
                                },
                                blue:{
                                    color: '#333',
                                    borderColor:'#91D5FF',
                                    borderWidth:1,
                                    borderRadius:2,
                                    padding:[10,15],
                                    lineHeight:30,
                                    backgroundColor:'#F1FBFF',
                                },
                                d:{
                                    color: '#737F8E',
                                    fontSize:12,
                                    lineHeight:30,
                                },
                                red:{
                                    color: '#333',
                                    borderColor:'#FFA91D',
                                    borderWidth:1,
                                    borderRadius:2,
                                    padding:[10,15],
                                    backgroundColor:'#fff3e0',
                                },
                                grey:{
                                    color: '#333',
                                    borderColor:'#ccc',
                                    borderWidth:1,
                                    borderRadius:2,
                                    padding:[10,15],
                                    backgroundColor:'#FAFBFC',
                                }

                            }
                        },

                        leaves: {
                            label: {
                                // position: 'bottom',
                                // verticalAlign: 'middle',
                                // align: 'center'
                            }
                        },

                        emphasis: {
                            focus: 'descendant'
                        },

                        expandAndCollapse: true,
                        animationDuration: 550,
                        animationDurationUpdate: 750
                    }
                ]
            };
            option && this.myChart.setOption(option);
        },
        getName(data){
            let name = "";
            if(data.oriGldId == 0){
                name = this.goldTransferTypeFun(data.goldTransferType);
            }else{
                name = this.goldTransferTypeFun2(data);
            }
            return name;
        },
        getStatusHtml(data){
            let className = 'blue';
            if(+data.gldStCd === 0 || +data.gldStCd === 5 || +data.gldStCd === 7){
                className = 'red';
            }
            else if(+data.gldStCd === 1 || +data.gldStCd === 6){
                className = 'blue';
            }
            else if(+data.gldStCd === 2 || +data.gldStCd === 3 || +data.gldStCd === 4 || +data.gldStCd === 8){
                className = 'grey';
            }
            if(data.isSelf){
                return ` {${className}|${data.name}（${this.utils.splitK(data.gldBal)} 元）}\n`;
            }else{
                return ` {${className}|${data.name}}\n`;
            }
        },
        GbGldStCdTrans (value) {
            value = String(value);
            switch (value) {
                case "0":
                    return '待签收';
                case "1":
                    return '已签收';
                case '2':
                    return '已撤销';
                case '3':
                    return '已拒绝';
                case '4':
                    return '确认已拒绝';
                case '5':
                    return '待确认';
                case '6':
                    return '已结清';
                case '7':
                    return '待复核';
                case '8':
                    return '复核已拒绝';
                default:
                    return null;
            }
        },
        goldTransferTypeFun(value){
            switch (+value) {
                case 0:
                    return '祺信开立';
                case 1:
                    return '祺信流转';
                case 2:
                    return '祺信融资';
                case 3:
                    return '祺信质押';
                case 4:
                    return '祺信解质';
                default:
                    return null;
            }
        },
        goldTransferTypeFun2({isSon,goldTransferType,goldTransferStCd,gldStCd}){
            // if(+isSon === 0){
            //     return "祺信签收";
            // }
            // else if(+isSon === 1){
               if(goldTransferType == 1){
                    if(goldTransferStCd == 1){
                        return "支付拒绝";
                    }
                    if(goldTransferStCd == 2 && gldStCd != 8){
                        return "支付撤销";
                    }
                    if(goldTransferStCd == 2 && gldStCd == 8){
                        return "祺信流转";
                    }
                    if(goldTransferStCd != 2 && goldTransferStCd != 1){
                        return "祺信流转";
                    }
                }
                if(goldTransferType == 2){
                    if(goldTransferStCd == 1){
                        return "融资拒绝";
                    }else{
                        return "祺信融资";
                    }
                }
                if(goldTransferType == 3){
                    if(goldTransferStCd == 1){
                        return "融资拒绝";
                    }else{
                        return "祺信质押";
                    }
                }
                if(goldTransferType == 4){
                    return "祺信解质";
                }
            // }
        }
    },
    watch: {},
    activated() {}
}
</script>
<style scoped>
    .right-oper{
        float: right;
        margin: 0 10px 10px 0;
    }
    .chart-box{
        background: #fff;
        margin-top:15px;
        padding-bottom:15px;
    }
</style>



// WEBPACK FOOTER //
// src/components/gold-page/gold-detail-flow-record.vue